export default __webpack_public_path__ + "static/media/naslovna1.832bd07f.jpeg";